import EventBus from './EventBus';

class EventBusPlugin {
	static install(Vue, options) {

		Vue.prototype.$bus = window.$eventBus = new EventBus();
		Vue.mixin({
			created() {
				if (this.$options.globalEvents && typeof this.$options.globalEvents === 'object') {
					for (let event in this.$options.globalEvents) {
						typeof this.$options.globalEvents[event] === 'function'
                        && this.$bus.on(event, this.$options.globalEvents[event], this);
					}
				}
			}
		});
	}
}

export default EventBusPlugin;